import { IconProps } from './types';

const UploadCloud = ({ color, dimension }: IconProps) => (
  <svg
    fill="none"
    height={dimension || 24}
    viewBox="0 0 24 24"
    width={dimension || 24}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1027_7279)">
      <path
        d="M16 16L12 12M12 12L8.00002 16M12 12V21M20.39 18.39C21.3654 17.8583 22.1359 17.0169 22.5799 15.9986C23.0239 14.9804 23.1162 13.8432 22.8422 12.7667C22.5682 11.6901 21.9435 10.7355 21.0667 10.0534C20.1899 9.37137 19.1109 9.00072 18 8.99998H16.74C16.4373 7.82923 15.8732 6.74232 15.09 5.82098C14.3068 4.89964 13.3249 4.16783 12.2181 3.68059C11.1114 3.19335 9.90857 2.96334 8.70014 3.00787C7.4917 3.05239 6.30909 3.37028 5.2412 3.93765C4.17331 4.50501 3.24793 5.30709 2.53464 6.28357C1.82135 7.26004 1.33871 8.38552 1.123 9.57538C0.907291 10.7652 0.964126 11.9885 1.28923 13.1532C1.61434 14.318 2.19926 15.3938 3.00002 16.3"
        stroke={color || '#101828'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </g>
    <defs>
      <clipPath id="clip0_1027_7279">
        <rect fill="white" height={dimension || 24} width={dimension || 24} />
      </clipPath>
    </defs>
  </svg>
);

export default UploadCloud;
